import React from 'react'
import './ContactLottie.css'

import Lottie from 'react-lottie';
import * as animationData from '../../../CommonComponents/animation/contact.json';

const ContactLottie = () => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <section className='pass_rest_success'>
                <div className='vdo-btn'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                    />
                </div>
            </section>
        </>
    )
}

export default ContactLottie